import React from "react";
import "./banner.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import config from "../../config";
import starsIcon from "../../assets/BannerSection/stars.svg";
import bannerTagArrow from "../../assets/BannerSection/banner-tag-arrow.svg";

export default function Banner() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  return (
    <section
      className={`banner-section ${isVisible ? "animate" : ""}`}
      ref={ref}
    >
      <div className="container">
        {/* Banner Content */}
        <div className="banner-content-wrapper">
          <div className="left-side">
            <div className="banner-tag">
              <img src={starsIcon} alt="stars-icon" />
              <div className="banner-tag-text">
                <p>
                  <span>Latest</span> AI Automation
                </p>
              </div>
              <img src={bannerTagArrow} alt="banner-tag-arrow" />
            </div>
            <h1>AI Aviator: Your Intelligent GUI Navigator</h1>
            <p>Navigate, Automate, Accelerate. Say goodbye to manual clicks!</p>
            <div className="banner-button-wrapper">
              <a href={config.bookdemo.Link}>
                <button className="banner-button">
                  <p>Book Demo</p>
                </button>
              </a>
            </div>
          </div>
          <div className="right-side">
            <img
              src="https://www.akira.ai/hubfs/ai-aviator-banner-image.svg"
              alt="ai-aviator-banner"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
